import flickityConfig from './flickity/flickity'

const config = {
    flickity: flickityConfig,
    instafeed: 'instafeed' // gallery wrapper CSS ID
}

export default config;